import { useState } from 'react';
import { ButtonGroup, Text } from 'shell/components';

const OPTIONS = [
    { key: 'task-board', value: 'Task Board', icon: 'taskBoard' },
    { key: 'timeline', value: 'Timeline', icon: 'timeline', badge: true },
    { key: 'disabled', value: 'Disabled', icon: 'hide', disabled: true },
];

const ButtonGroupDemo = () => {
    const [selected, setSelected] = useState(OPTIONS[0].key);

    return (
        <>
            <Text variant={'sh1'}>ButtonGroup</Text>
            <ButtonGroup options={OPTIONS} selected={selected} onChange={setSelected} />
        </>
    );
};

export default ButtonGroupDemo;
